// import dayjs from 'dayjs'

/**
 * 生成 username
 * @param {string|null} employeeId
 * @param {string|null} accountEmail
 * @returns {string} username
 */
const GenerateUsername = (employeeId, accountEmail) => {
  // const now = dayjs().format('YYYYMMDDHHmm') // 取到時分
  if (employeeId) {
    return `${employeeId}`
  }
  if (accountEmail) {
    const emailPrefix = accountEmail.split('@')[0]
    return `${emailPrefix}`
  }
  return `user` // fallback
}

export default GenerateUsername
